<template>
  <layout class="support" :useBanner="false">

    <!-- 首图 -->
    <Banner :data="info.banner" />

    <!-- 培训视频 -->
<!--    <Webank :data="info.wefinance" />-->

    <!-- 培训视频 -->
<!--    <Webank :data="info.we2000" type="is-weight" />-->

    <!-- 培训视频 -->
    <Train :data="info.train" />

    <!-- 新闻资讯 -->
    <News :data="info.news" />

    <!-- 底部二维码 -->
    <Bottom :data="info.bottom" />
  </layout>
</template>

<script>
import layout from '@/components/layout/layout'

import Banner from './Banner'
import Webank from './Webank'
// import TrainingVideo from './TrainingVideo'
import News from './News'
import Bottom from './Bottom'
import Train from './Train'

export default {
  name: 'Home',
  components: {
    layout,
    Banner,
    Webank,
    Train,
    News,
    Bottom
  },
  computed: {
    info () {
      return this.$t('pm')
    }
  }
}
</script>
<style lang="scss" scoped>

.banner-wrapper {
  width: 1200px;
  margin: 0 auto;
}

.banner-img {
  width: 362px; height: 180px;
  margin-top: 178px;
}

@include mobile {

}
</style>
